{
  "version": 1,
  "asset_id": "b04f6841-af4c-4981-a550-ad0b3fa22798",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/b04f6841-af4c-4981-a550-ad0b3fa22798/resultado_1.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/b04f6841-af4c-4981-a550-ad0b3fa22798/resultado_1.png",
  "original_filename": "resultado_1.png",
  "size": 1036557,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:03Z"
}
